<template>
  <div class='w-100'>
    <ModalTabVideos
      :instructionalVideos="instructionalVideos"
      :timer="timer"
    >
    </ModalTabVideos>

    <b-modal
      header-bg-variant='warning'
      ref="notify-agents-front-page"
      id="notify-agents-front-page"
      title='Agentes movidos'
      hide-footer
      @hidden="hideNotifyAgentsFrontPage()"
    >
      <p>
        <strong class='text-danger'>Atenção: </strong>
        Os agentes adicionados anteriormente na <strong>página {{ previousPage }}</strong> foram automaticamente movidos para a página 1. Essa realocação é
        feita para manter a organização dos agentes exibidos.
      </p>
      <b-row cols="12" class='mt-3'>
        <b-col cols="12">
          <base-button
            success
            class="w-100"
            @click="hideNotifyAgentsFrontPage()"
           >
            Ok
          </base-button>
        </b-col>
      </b-row>
    </b-modal>

    <SurveySatisfaction/>

    <SurveyRecommendation/>

    <importer-agents>

    </importer-agents>

    <component v-bind:is="tabView" @open-survey="openDownloadSurvey" />

    <section class="d-flex justify-content-center" v-if="lookingForAgents && showPaginationTab(tabView)">
      <p class='mt-2 btn-outline-primary text-loading'>Carregando agentes...</p>
      <section class='px-3'>
        <b-spinner class='loadingLookingForAgents' variant="primary" label="Spinning"></b-spinner>
      </section>
    </section>

    <div class='w-100 mb-5 mt-3' v-if="showPaginationTab(tabView)">
      <b-pagination
        v-if='summaryMeta.total > agentsPerPage'
        align="center"
        :per-page='perPage'
        v-model="summaryMeta.skip"
        :total-rows="summaryMeta.total"
        pills
        first-text="⏮"
        prev-text="⏪"
        next-text="⏩"
        last-text="⏭"
        @page-click='setPage'
        size="lg"
      >
      </b-pagination>
    </div>
  </div>
</template>

<script>
import Acigh from '@/components/LegalSearch/Acgih'
import ImporterAgents from '@/components/LegalSearch/Modal/ImporterAgents.vue'
import Insalubrity from '@/components/LegalSearch/Insalubrity'
import Ltcat from '@/components/LegalSearch/Ltcat'
import Report from '@/components/LegalSearch/Report'
import Summary from '@/components/LegalSearch/Summary'
import QuantitativeAssessment from '@/components/LegalSearch/QuantitativeAssessment/QuantitativeAssessment'
import PreventionistLimits from '@/components/LegalSearch/PreventionistLimits/PreventionistLimits'
import Pcmso from '@/components/LegalSearch/Pcmso/Pcmso'
import Gro from '@/components/LegalSearch/Gro/Gro'
import { isOpenSurvey } from '../utils/surveys'
import SurveySatisfaction from '@/components/SurveySatisfaction.vue'
import SurveyRecommendation from '@/components/SurveyRecommendation.vue'
import FilterAgentsLegalConsultation from '@/components/LegalSearch/Modal/FilterAgentsLegalConsultation.vue'
import { mapActions, mapGetters } from 'vuex'
import eventBus from '@/utils/eventBus'
import ModalTabVideos from '../components/InstructionalVideos/components/ModalTabVideos.vue'
export default {
  data() {
    return {
      tabView: 'Summary',
      openSurvey: {
        download: false,
        login: false,
        currentBtn: '',
      },
      previousPage: 1,
      instructionalVideos: [],
      timer: false,
    }
  },
  created() {
    this.$store.state.pagetitle = '(Resumo)'
    this.changeView('Summary', 'CLICOU_ABA_SELECAO_DE_AGENTES')
    this.openSurvey.login = isOpenSurvey('login')
  },
  async mounted() {
    if(this.user.showPopupSurveyRecommendation) {
      this.$bvModal.show('surveyRecommendation')
    }
    if(this.user.showSatisfactionSurveyPopup) {
      this.$bvModal.show('surveySatisfaction')
    }
    await this.ensureUserPreferences()
    await this.load()
    await this.setTabView('Summary')
    eventBus.$on('updateTab', async (component) => {
      this.tabView = component
    })

    eventBus.$on('showModalTabVideos', async (body) => {
      const {instructionalVideos, timer} = body
      this.instructionalVideos = instructionalVideos
      this.timer = timer
      setTimeout(() => {
        this.$bvModal.show('modalTabVideos')
      },100)
    })
    if (this.$route.query.aba) {
      await this.changeView('Gro', 'CLICOU_ABA_SELECAO_DE_AGENTES')
      await this.setTabView('Gro')
    }
    await this.handleGetAddedAgentsLimitation(this.user)
    await this.loadRationaleGroups()
    await this.loadListOfPhrases()
    if (this.user && this.user.role !== 'admin') {
      const log = {
        action: 'ACESSOU_PAGINA_CONSULTA_LEGAL',
      }
      await this.createUserActionLogs(log)
    }
    await this.handleGetObjectivesAnalysis()
    await this.handleGetByTab('Summary')
  },
  components: {
    ModalTabVideos,
    Acigh,
    Insalubrity,
    Ltcat,
    Report,
    Summary,
    SurveySatisfaction,
    QuantitativeAssessment,
    Pcmso,
    Gro,
    FilterAgentsLegalConsultation,
    ImporterAgents,
    SurveyRecommendation,
    PreventionistLimits,
  },
  computed: {
    perPage(){
      const { totalPage, total } = this.summaryMeta
      return Math.ceil(total / totalPage)
    },
    user() {
      return this.$store.getters['user/current']
    },
    renew() {
      return this.$store.getters['user/renewable']
    },
    summaryMeta() {
      return this.$store.getters['legalSearch/summaryMeta']
    },
    agentsPerPage() {
      return this.$store.getters['legalSearch/agentsPerPage']
    },
    lookingForAgents() {
      return this.$store.getters['legalSearch/lookingForAgents']
    },
    agentsStartList() {
      return this.$store.getters['legalSearch/agentsStartList']
    },
    ...mapGetters('companyLegalConsultation', {
      importedCompany: 'importedCompany'
    }),
  },
  methods: {
    ...mapActions('userActionLogs', {
      createUserActionLogs: 'createUserActionLogs',
    }),
    ...mapActions('rationaleGroups', {
      loadRationaleGroups: 'loadRationaleGroups',
    }),
    ...mapActions('phraseListH', {
      loadListOfPhrases: 'loadListOfPhrases',
    }),
    ...mapActions('userPlans', {
      handleGetAddedAgentsLimitation: 'handleGetAddedAgentsLimitation',
    }),
    ...mapActions('legalSearch', {
      setSkip: 'setSkip',
      summaryClear: 'summaryClear',
      setTabView: 'setTabView',
      resetAgentsStartList: 'resetAgentsStartList',
    }),
    ...mapActions('objectivesAnalysis', {
      handleGetObjectivesAnalysis: 'handleGetObjectivesAnalysis',
    }),
    ...mapActions('instructionalVideo', {
      handleGetByTab: 'handleGetByTab',
    }),
    ...mapActions('userPreferences', {
      handleGetUserPreferences: 'handleGetUserPreferences',
      handleCreateUserPreferences: 'handleCreateUserPreferences',
    }),
    async ensureUserPreferences() {
      try {
        const { userPreferences } = await this.handleGetUserPreferences(this.user.id)
        const { _id } = userPreferences || {}
        if (_id) {
          return
        }
        await this.handleCreateUserPreferences({ user: this.user.id })
        await this.handleGetUserPreferences(this.user.id)
      } catch (e) {
        //
      }
    },
    async load() {
      await this.$store.dispatch('legalSearch/load', this.user.id)
    },
    showPaginationTab(tabView){
      if(tabView == 'Gro' || tabView == 'Insalubrity' || tabView == 'Summary'|| tabView == 'Ltcat'|| tabView == 'Pcmso'){
        return false
      }
      if(tabView == 'PreventionistLimits' && this.importedCompany && this.importedCompany._id){
        return false
      }
      return true
    },
    buttonActive(view) {
      return view === this.tabView
    },

    async changeView(component, action, name) {
      this.$route.meta.subtitle = name
      this.currentBtn = component
      this.tabView = component
      if (this.user && this.user.role !== 'admin') {
        const log = {
          action,
        }
        await this.createUserActionLogs(log)
      }
    },

    openDownloadSurvey() {
      this.openSurvey.download = isOpenSurvey('download')
    },
    hideNotifyAgentsFrontPage(){
      this.$bvModal.hide('notify-agents-front-page')
      this.resetAgentsStartList()
    },
    async setPage(event, page) {
      this.previousPage = this.summaryMeta.skip
      await this.summaryClear()
      await this.setSkip(page)
      await this.load()
      if(this.agentsStartList && this.agentsStartList.length > 0) {
        this.$bvModal.show('notify-agents-front-page')
      }
    },
  },
  beforeDestroy: function () {
    this.$store.state.pagetitle = ''
    eventBus.$off('updateTab')
    eventBus.$off('showModalTabVideos')
  },
}
</script>
<style>
.btn-orientations{
  padding: 5px 8px;
  border-radius: 6px;
  background: var(--navy-blue);
  font-weight: 700;
  font-size: 14px;
  color: #FFFFFF;
}
.loadingLookingForAgents{
  width: 2rem;
  height: 2rem;
}
.custom-tooltip > .tooltip-inner {
  background: #000000;
  max-width: 800px !important;
  width: 800px !important;
}
</style>
<style scoped>

.link {
  text-decoration: none;
}
.tabs-inventory {
  border-radius: 10px;
}
table.sticky th {
  position: sticky;
  top: 0px;
}

.active {
  background-color: #022245 !important;
  color: var(--white) !important;
  font-weight: 700 !important;
  outline: none !important;
  border: none !important;
}

button.btn.btn.btn-outline-primary.btn-secondary {
  border-radius: 0;
  background: var(--white);
}

button.btn.btn.btn-outline-primary.btn-secondary.active,
button.btn.btn.btn-outline-primary.btn-secondary:hover {
  background-color: var(--blue);
}
</style>
